import Vue from 'vue'
import { addGA } from '@/utils/assist'

export default new Vue({
  data () {
    return {
      uid: null,
      gems: 0,
      loading: { // loading dialog
        show: false,
        opacity: false
      },
      toast: {
        show: false,
        isMsg: false,
        text: ''
      },
      rule: { // rule dialog
        show: false,
        content: ''
      },
      history: { // history dialog
        show: false,
        data: [] // history 相关数据
      },
      buyDialog: {
        show: false
      },
      confirmDialog: {
        show: false,
        type: ''
      },
      productsDialog: {
        show: false,
        data: []
      },
      discountInfo: {
        show: false,
        discount: 0
      },
      shareInfo: {
        show: false
      },
      alertShow: false,
      alertTitle: '',
      alertContent: '',
      rewardPool: [], // 商品池
      discountPool: [], // 折扣池
      discountDinate: {
        top: 0,
        left: 0
      },
      // 新增

      // audio相关
      bgmStatus: null,
      showNameTimer: null,
      activeIndex: -1,
      enable: -1, // 当前抽中但是未使用
      refreshFreeTimes: 0, // 剩余的免费刷新次数
      refreshCost: 0, // 刷新cost
      deltaAngle: 0,
      prevRotateIndex: 0, // 上一次旋转的状态
      animating: false, // 处于动画过程中
      activePrize: {}, // 当前购买的商品
      finish: 0, // 1表示游戏结束
      canRefresh: 1, // 1表示可以刷新
      purchased: [], // 已购
      currentShareDiscount: {},
      refreshNotice: true,
      originDiscountPool: [],

      // sound相关
      clickSound: false,
      mute: false,
      drawSound: false,

      // transify
      transify: {
        COMMON_BACK: 'back',
        COMMON_CANCEL: 'cancel',
        COMMON_CONFIRM: 'confirm',
        COMMON_CONTINUE_PURCHASE: 'continue to buy',
        COMMON_HISTORY_DRAW: '',
        COMMON_HISTORY_PURCHASE: '',
        COMMON_HISTORY_REDEEM: '',
        COMMON_NO: 'no',
        COMMON_PURCHASE: 'purchase',
        COMMON_PURCHASED: 'purchased',
        COMMON_QUANTITY_MAX: 'max',
        COMMON_TIPS_ITEM: 'the rewards will be sent directly to your vault',
        COMMON_YES: 'Yes',
        POPUP_NO_REMIND: "Don't remind me again",
        POPUP_TITLE_REDEEM: 'Congratulation! You got',
        POPUP_TITLE_UNIQUE: 'The unique items you owe',
        UNIQUE_BUY_ALREADY_HAVE:
          'You already own this item, if you purchase it again, it will be converted to FF tokens.',
        UNIQUE_BUY_ALREADY_HAVE_PART:
          'You already owe some of the item(s) you selected. If you purchase again, you will receive FF tokens instead.',
        UNIQUE_REDEEM_ALREADY_HAVE:
          'You already own this item, if you receive it again, it will be converted to FF tokens.',
        TOAST_ERROR_CODE: 'unknown error, error code {code}',
        TOAST_EVENT_CLOSED_AWHILE: 'The event is closed temporary',
        TOAST_EVENT_END: 'Event ended',
        TOAST_EVENT_NOTOPEN: "event hasn't started",
        TOAST_GEM_NOT_ENOUGH: 'insufficient diamonds, please top up and come back again',
        TOAST_LOGIN_FAILED: 'login failed',
        TOAST_NETWORK_BUSY: 'Server busy, please try again later',
        TOAST_NETWORK_ERROR: 'Network connection error, please try again later',
        TOAST_OPERATE_BUSY: 'Too many requests, please try again later',
        TOAST_PAY_FAILED: 'purchase failed',
        TOAST_SERVER_BUSY: '',
        TOAST_SERVER_NOTWORK: 'service unavailable',
        TOAST_SERVER_TIMEOUT: 'service timeout',
        TOAST_WRONG_REGION: 'This event is not available for your region'
      }
    }
  },
  methods: {
    checkGem (price) {
      let flag = true
      if (this.gems < price) {
        flag = false
      }
      return flag
    },
    addGA (event, msg) { // google 统计
      addGA(event, msg)
    },
    /**
     * 错误处理
     * @param {String} errCode 错误码
     * @return toast | dialog 组件
     */
    handleError (errCode) {
      // TODO 错误信息提示窗
      this.handleToast(true, errCode, true)
      addGA('msgError', errCode)
    },
    handleToast (bool, text, isMsg = false) { // toast
      this.toast.show = bool
      this.toast.text = this.transify[text] || this.transify['TOAST_NETWORK_ERROR']
      this.toast.isMsg = isMsg
    },
    handleLoading (bool, opacity, delay) { // loading
      if (bool === true) {
        this.loading.opacity = opacity
        this.loading.show = bool
      } else {
        setTimeout(() => {
          this.loading.show = bool
          this.loading.opacity = opacity
        }, delay)
      }
    },
    formatRewardPool (totalPool, currentPoolPkList, totalPurchased) {
      return currentPoolPkList.map(pk => {
        const item = totalPool.filter(item => item.pk === pk)[0]
        return {...item, purchased: totalPurchased.indexOf(item.pk) !== -1}
      })
    },
    formatDiscountList (discountList, disable, enable) {
      const grandDiscountIndex = discountList.findIndex(item => item.type === 0)
      const grandDiscount = discountList.splice(grandDiscountIndex, 1)[0]
      const sortedDiscountList = discountList.sort((a, b) => a.pos - b.pos)
      const newDiscountList = [grandDiscount, ...sortedDiscountList]
      return newDiscountList.map(item => ({
        pk: item.pk,
        discountType: item.type,
        discount: item.value,
        status: enable === item.pk ? 1 : disable.indexOf(item.pk) !== -1 ? 2 : 0 // 0还未抽过，2表示抽中并使用过
        }))
    },
    refresh (cost) {
      this.$api.refresh({
        cost
      }).then(res => {
        this.clickSound = true
        this.gems -= cost
        if (this.refreshFreeTimes > 0) {
          this.refreshFreeTimes -= 1
        }
        // 更新奖池
        this.canRefresh = res.data.can_refresh
        this.rewardPool = this.formatRewardPool(this.productsDialog.data.slice(), res.data.pool, this.purchased)
        this.handleToast(true, 'LUCKY_REFRESH_SUCCESS')
        this.addGA('refresh', 'success')
      })
    }
  },
  watch: {
    activeIndex (current) {
      if (current >= 0) {
        clearTimeout(this.showNameTimer)
        this.showNameTimer = setTimeout(() => {
          this.activeIndex = -1
          clearTimeout(this.showNameTimer)
        }, 1500)
      } else {
        clearTimeout(this.showNameTimer)
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/bus/index.js